import { render, staticRenderFns } from "./TaskDuration.vue?vue&type=template&id=cc117252&"
import script from "./TaskDuration.vue?vue&type=script&lang=js&"
export * from "./TaskDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports